/*EXCELLERATE CONSTANTS*/
export const JANUARY = 'january';
export const FEBRUARY = 'february';
export const MARCH = 'march';
export const APRIL = 'april';
export const MAY = 'may';
export const JUNE = 'june';
export const JULY = 'july';
export const AUGUST = 'august';
export const SEPTEMBER = 'september';
export const OCTOBER = 'october';
export const NOVEMBER = 'november';
export const DECEMBER = 'december';
export const COPIED_TO_CLIPBOARD = "copiedToClipboard";
export const SAVE = "save";
export const SAVED = "saved";
export const DELETE = "delete";
export const DELETED = "deleted";
export const CANCEL = "cancel";
export const CLOSE = "close";
export const UPLOAD = "upload";
export const RESET = "reset";
export const ERROR = "error";
export const GENERAL_ERROR_MESSAGE = "generalErrorMessage";
export const GENERAL_ERROR_UPDATE_PAGE_MESSAGE = "generalErrorUpdatePageMessage";
export const GENERAL_ERROR_CONTACT_MESSAGE = "generalErrorContactMessage";
export const GENERAL_ERROR_AUTH_MESSAGE = "generalErrorAuthMessage";
export const GENERAL_ERROR_REPORT_MESSAGE = "generalErrorReportMessage";
export const REDIRECTION_MESSAGE = "redirectionMessage";
export const REDIRECTION_ERROR_MESSAGE_PART_ONE = "redirectionErrorMessagePartOne";
export const REDIRECTION_ERROR_MESSAGE_PART_TWO = "redirectionErrorMessagePartTwo";
export const PAGE_MISSING_MESSAGE = "pageMissingMessage";
export const AUTH_ERROR_MESSAGE = "authErrorMessage";
export const BACK_TO_HOME_MESSAGE = "backToHomeMessage";
export const DATE_PLACEHOLDER = "datePlaceholder";
export const CHOOSE_VISIBLE_COLUMNS_TOOLTIP = "chooseVisibleColumnsTooltip";
export const RESET_FILTERS_TOOLTIP = "resetFiltersTooltip";
export const DRAG_FILES_HERE = "dragFilesHere";
export const INVALID_FILE_TYPE = "invalidFileType";
export const NO_DATA_TO_DISPLAY = "noDataToDisplay";
export const CONFIRMED_BOOKING = "confirmedBooking";
export const RESERVE_BOOKING = "reserveBooking";
export const CANCELLED_BOOKING = "cancelledBooking";
export const ABSENT_BOOKING = "absentBooking";
export const FINISHED_BOOKING = "finishedBooking";
export const CERTIFIED_BOOKING = "certifiedBooking";
export const TRAINEE_CERTIFIED_BOOKING = "traineeCertifiedBooking";
export const EXTERNAL_CERTIFIED_BOOKING = "externalCertifiedBooking";
export const RETROACTIVE_CERTIFIED_BOOKING = "retroactiveCertifiedBooking";
export const EMAIL_NOTIFICATIONS_TRUE = "emailNotificationsTrue";
export const EMAIL_NOTIFICATIONS_FALSE = "emailNotificationsFalse";
export const ABSENT_BOOKING_DESC = "absentBookingDesc";
export const CERTIFIED_BOOKING_DESC = "certifiedBookingDesc";
export const TRAINEE_CERTIFIED_BOOKING_DESC = "traineeCertifiedBookingDesc";
export const EXTERNAL_CERTIFIED_BOOKING_DESC = "externalCertifiedBookingDesc";
export const RETROACTIVE_CERTIFIED_BOOKING_DESC = "retroactiveCertifiedBookingDesc";
export const CANCELLED_BOOKING_DESC = "cancelledBookingDesc";
export const COURSE_TEMPLATE_TOOLTIP = "courseTemplateTooltip";
export const TEACHER_REPORT_TYPE = "teacherReportType";
export const ALL_TEACHERS_REPORT_TYPE = "allTeachersReportType";
export const COURSE_REPORT_TYPE = "courseReportType";
export const ALL_COURSES_REPORT_TYPE = "allCoursesReportType";
export const ALL_CERTIFICATES_REPORT_TYPE = "allCertificatesReportType";
export const BONUS_CERTIFICATES_REPORT_TYPE = "bonusCertificatesReportType";
export const COURSE_STATUS_NONE = "courseStatusNone";
export const COURSE_STATUS_SCHEDULED = "courseStatusScheduled";
export const COURSE_STATUS_INPROGRESS = "courseStatusInProgress";
export const COURSE_STATUS_FINISHED = "courseStatusFinished";
export const COURSE_STATUS_CANCELLED = "courseStatusCancelled";
export const COURSE_TEACHER_ROLE = "courseTeacherRole";
export const COURSE_ASSISTANT_TEACHER_ROLE = "courseAssistantTeacherRole";
export const COURSE_PARTICIPANT_ROLE = "courseParticipantRole";
export const TEACHER_HOURS_COMP_TYPE = "teacherHourCompType";
export const TEACHER_PAID_COMP_TYPE = "teacherPaidCompType";
export const COURSE_INTERNAL_CATEGORY = "courseInternalCategory";
export const COURSE_EXTERNAL_CATEGORY = "courseExternalCategory";
export const COURSE_TRAINEE_CATEGORY = "courseTraineeCategory";
export const COURSE_HIGHER_EDU_CATEGORY = "courseHigherEduCategory";
export const COURSE_OTHER_CATEGORY = "courseOtherCategory";
export const COURSE_LEADERSHIP_CATEGORY = "courseLeadershipCategory";
export const COURSE_SWE_LANG = "courseSweLang";
export const COURSE_ENG_LANG = "courseEngLang";
export const COURSE_DIGITAL_FORMAT = "courseDigitalFormat";
export const COURSE_IN_PERSON_FORMAT = "courseInPersonFormat";
export const COURSE_HYBRID_FORMAT = "courseHybridFormat";
export const REPORT_NUM_PARTICIPANT_OPT = "reportNumParticipantsOpt";
export const REPORT_NUM_CANCELLATIONS_OPT = "reportNumCancellationsOpt";
export const REPORT_NUM_CERT_OPT = "reportNumCertOpt";
export const REPORT_NUM_COURSES_OPT = "reportNumCoursesOpt";
export const REPORT_NUM_HOURS_OPT = "reportNumHoursOpt";
export const REPORT_PARTICIPANT_INFO_OPT = "reportParticipantInfoOpt";
export const SEARCH_RESULTS = "searchResults";
export const SEARCH_RESULTS_PAGING_LABEL = "searchResultsPagingLabel";
export const COURSE_PRIM_ACT_BUTTON_ENROLL_ME = "coursePrimActButtonEnrollMe";
export const COURSE_PRIM_ACT_BUTTON_UNENROLL_ME = "coursePrimActButtonUnenrollMe";
export const COURSE_PRIM_ACT_BUTTON_ENROLL_ME_AS_RESERVE = "coursePrimActButtonEnrollMeAsReserve";
export const COURSE_PRIM_ACT_BUTTON_ENROLLMENT_CLOSED = "coursePrimActButtonEnrollmentClosed";
export const COURSE_PRIM_ACT_BUTTON_NO_SPOTS_OPEN = "coursePrimActButtonNoSpotsOpen";
export const COURSE_PRIM_ACT_BUTTON_COURSE_SIGN_UP_CLOSED = "coursePrimActButtonCourseSignupClosed";
export const COURSE_PRIM_ACT_BUTTON_COURSE_CANCEL_CLOSED = "coursePrimActButtonCourseCancelClosed";
export const COURSE_PRIM_ACT_BUTTON_COURSE_SIGN_UP_CLOSED_NO_LECTURES = "coursePrimActButtonCourseSignupClosedNoLectures";
export const COURSE_PRIM_ACT_BUTTON_CLOSED_DUE_TO_TEACHER = "coursePrimActButtonClosedDueToTeacher";
export const COURSE_PRIM_ACT_BUTTON_USER_COLL_BOOKING = "coursePrimActButtonUserHasOverlappingBookingsWarn";
export const CONFLICTING_BOOKING_ERROR = "conflictingBooking";

export const COURSE_DETAILS_DELETE_COURSE_WARN = "courseDetailsDeleteCourseWarn";
export const COURSE_DETAILS_HEADER_YOUR_STATUS = "courseDetailsHeaderYourStatus";
export const COURSE_DETAILS_HEADER_EDIT_COURSE_LABEL = "courseDetailsHeaderEditCourse";
export const COURSE_DETAILS_HEADER_ADD_LECTURE_LABEL = "courseDetailsHeaderAddLecture";
export const COURSE_DETAILS_HEADER_EDIT_BOOKINGS_LABEL = "courseDetailsHeaderEditBookings";
export const COURSE_DETAILS_HEADER_DUPLICATE_COURSE_LABEL = "courseDetailsHeaderDuplicateCourse";
export const COURSE_DETAILS_HEADER_DELETE_COURSE_LABEL = "courseDetailsHeaderDeleteCourse";
export const COURSE_DETAILS_HEADER_CREATE_LECTURE_TOOLTIP = "courseDetailsHeaderCreateLectureToolTip";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_LABEL = "courseDetailsHeaderEmailConfirmedBookings";
export const COURSE_DETAILS_HEADER_EMAIL_RESERVE_BOOKINGS_LABEL = "courseDetailsHeaderEmailReserveBookings";
export const COURSE_DETAILS_INFO_EMAIL_CONFIRMED_BOOKINGS_SENDER_LABEL = "courseDetailsInfoEmailConfirmedBookingsSender";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_SUBJECT_LABEL = "courseDetailsHeaderEmailConfirmedBookingsSubject";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_MESSAGE_LABEL = "courseDetailsHeaderEmailConfirmedBookingsMessage";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_LABEL = "courseDetailsHeaderEmailConfirmedBookingsAttachments";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_ADD_LABEL = "courseDetailsHeaderEmailConfirmedBookingsAttachmentsAdd";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_REMOVE_LABEL = "courseDetailsHeaderEmailConfirmedBookingsAttachmentsRemove";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_SEND_LABEL = "courseDetailsHeaderEmailConfirmedBookingsSend";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_SUBJECT_VALIDATION = "courseDetailsHeaderEmailConfirmedBookingsSubjectValidation";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_CONTENT_VALIDATION = "courseDetailsHeaderEmailConfirmedBookingsContentValidation";
export const COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_MAX_SIZE_VALIDATION = "courseDetailsHeaderEmailConfirmedBookingsAttachmentsMaxSizeValidation";

export const COURSE_DETAILS_BODY_EMPTY_COURSE_DESCRIPTION = "courseDetailsBodyEmptyCourseDescription";
export const COURSE_DETAILS_BODY_INFO_LABEL = "courseDetailsBodyInfoLabel";
export const COURSE_DETAILS_BODY_LECTURES_LABEL = "courseDetailsBodyLecturesLabel";
export const COURSE_DETAILS_BODY_PARTICIPANTS_LABEL = "courseDetailsBodyParticipantsLabel";
export const COURSE_DETAILS_BODY_RESERVES_LABEL = "courseDetailsBodyReservesLabel";
export const COURSE_DETAILS_BODY_CANCELLATIONS_LABEL = "courseDetailsBodyCancellationsLabel";
export const COURSE_DETAILS_DESCRIPTION_LABEL = "courseDetailsDescriptionLabel";

export const GENERAL_COURSE_INFO_TEACHER_LABEL = "generalCourseInfoTeacherLabel";
export const GENERAL_COURSE_INFO_COURSE_DATE_LABEL = "generalCourseInfoCourseDateLabel";
export const GENERAL_COURSE_INFO_NO_SET_COURSE_DATE = "generalCourseInfoNoSetCourseDate";
export const GENERAL_COURSE_INFO_FINAL_ENROLLMENT_DATE_LABEL = "generalCourseInfoFinalEnrollmentDate";
export const GENERAL_COURSE_INFO_NO_SET_FINAL_ENROLLMENT_DATE = "generalCourseInfoNoSetFinalEnrollmentDate";
export const GENERAL_COURSE_INFO_COURSE_LENGTH_LABEL = "generalCourseInfoCourseLength";
export const GENERAL_COURSE_INFO_NO_SET_COURSE_LENGTH = "generalCourseInfoNoSetCourseLength";
export const DAY = "day";
export const WEEK = "week";
export const DAYS = "days";
export const WEEKS = "weeks";
export const MONTH = "month";
export const MONTHS = "months";
export const HOUR = "hour";
export const HOURS = "hours";
export const YES = "yes";
export const NO = "no";
export const SHOW_ALL = "showAll";
export const ACTIVE = "active";
export const INACTIVE = "inactive";
export const SELECT = "select";
export const GENERAL_COURSE_INFO_STATUS_LABEL = "generalCourseInfoStatusLabel";
export const GENERAL_COURSE_INFO_CATEGORY_LABEL = "generalCourseInfoCategoryLabel";
export const GENERAL_COURSE_INFO_LANGUAGE_LABEL = "generalCourseInfoLanguageLabel";
export const GENERAL_COURSE_INFO_LECTURE_TYPE_LABEL = "generalCourseInfoLectureTypeLabel";
export const GENERAL_COURSE_INFO_MAX_NUM_PART_LABEL = "generalCourseInfoMaxNumPartLabel";
export const GENERAL_COURSE_INFO_MAX_NUM_RES_LABEL = "generalCourseInfoMaxNumResLabel";
export const GENERAL_COURSE_INFO_ADDRESS_LABEL = "generalCourseInfoAddressLabel";
export const GENERAL_COURSE_INFO_NO_SET_ADDRESS = "generalCourseInfoNoSetAddress";
export const GENERAL_COURSE_INFO_MEETING_LINK_LABEL = "generalCourseInfoMeetingLinkLabel";
export const GENERAL_COURSE_INFO_PRICE_LABEL = "generalCourseInfoPriceLabel";
export const GENERAL_COURSE_INFO_TRAVEL_SUPPLEMENT_LABEL = "generalCourseInfoTravelSupplementLabel";
export const GENERAL_COURSE_INFO_NO_SET_MEETING_LINK = "generalCourseInfoNoSetMeetingLink";
export const COURSE_LECTURES_NO_LECTURES = "courseLecturesNoLectures";
export const COURSE_LECTURES_LECTURE_DATE_LABEL = "courseLecturesLectureDateLabel";
export const COURSE_LECTURES_LECTURE_TIME_LABEL = "courseLecturesLectureTimeLabel";
export const COURSE_BOOKINGS_NO_PARTICIPANTS = "courseBookingsNoParticipants";
export const COURSE_BOOKINGS_STATUS_LABEL = "courseBookingsStatusLabel";
export const COURSE_CERTIFICATION_TYPE_LABEL = "courseCertificationTypeLabel";
export const COURSE_CERTIFICATION_TAGS_LABEL = "courseCertificationTagsLabel";
export const INDEPENDENT_CERTIFICATION_LABEL = "independentCertificationLabel";
export const INDEPENDENT_CERTIFICATION_DESC = "independentCertificationDesc";
export const COURSE_MODALS_NAME_LABEL = "courseModalsNameLabel";
export const COURSE_MODALS_TEACHER_LABEL = "courseModalsTeacherLabel";
export const COURSE_MODALS_DESCRIPTION_LABEL = "courseModalsDescriptionLabel";
export const COURSE_MODALS_MAX_BOOKINGS_LABEL = "courseModalsMaxNumBookingsLabel";
export const COURSE_MODALS_MAX_RESERVES_LABEL = "courseModalsMaxNumReserveslabel";
export const COURSE_MODALS_STATUS_LABEL = "courseModalsStatusLabel";
export const COURSE_MODALS_CATEGORY_LABEL = "courseModalsCategoryLabel";
export const COURSE_MODALS_LANG_LABEL = "courseModalsLanguageLabel";
export const COURSE_MODALS_FORMAT_LABEL = "courseModalsFormatLabel";
export const COURSE_MODALS_ADDRESS_LABEL = "courseModalsAddressLabel";
export const COURSE_MODALS_MEET_LINK_LABEL = "courseModalsMeetingLinkLabel";
export const COURSE_MODALS_PRICE_LABEL = "courseModalsPriceLabel";
export const COURSE_MODALS_TRAVEL_SUPPLEMENT_LABEL = "courseModalsTravelSupplementLabel";
export const COURSE_MODALS_EMAIL_NOTIF_LABEL = "courseModalsEmailNotifications";
export const COURSE_MODALS_NO_NAME_VALI = "courseModalsNoNameValidation";
export const COURSE_MODALS_TO_LONG_NAME_VALI = "courseModalsToLongCourseNameValidation";
export const COURSE_MODALS_NO_TEACHER_VALI = "courseModalsNoTeacherValidation";
export const COURSE_MODALS_NO_MAX_BOOK_VALI = "courseModalsNoMaxBookValidation";
export const COURSE_MODALS_BOOK_EXCEEDS_MAX_NUM_VALI = "courseModalsBookExceedsMaxNumValidation";
export const COURSE_MODALS_TO_HIGH_MAX_BOOK_VALI = "courseModalsToHighMaxBookValidation";
export const COURSE_MODALS_TO_LOW_MAX_BOOK_VALI = "courseModalsToLowMaxBookValidation";
export const COURSE_MODALS_RES_EXCEEDS_MAX_NUM_VALI = "courseModalsReservesExceedsMaxNumValidation";
export const COURSE_MODALS_TO_HIGH_MAX_RES_VALI = "courseModalsToHighMaxResValidation";
export const COURSE_MODALS_NO_STATUS_VALI = "courseModalsNoStatusValidation";
export const COURSE_MODALS_NO_CATE_VALI = "courseModalsNoCategoryValidation";
export const COURSE_MODALS_NO_LANG_VALI = "courseModalsNoLangValidation";
export const COURSE_MODALS_NO_FORMAT_VALI = "courseModalsNoFormatValidation";
export const COURSE_MODALS_NO_ADDRESS_VALI = "courseModalsNoAddressValidation";
export const COURSE_MODALS_EMAIL_SEND_LABEL = "courseModalsEmailSendLabel";
export const CERTIFICATE_MODALS_NAME_LABEL = "certificateModalsNameLabel";
export const CERTIFICATE_MODALS_DATE_LABEL = "certificateModalsDateLabel";
export const CERTIFICATE_MODALS_TAGS_LABEL = "certificateModalsTagsLabel";
export const CERTIFICATE_MODALS_NO_NAME_VALI = "certificateModalsNoNameValidation";
export const CERTIFICATE_MODALS_TO_LONG_NAME_VALI = "certificateModalsToLongCertificateNameValidation";
export const CERTIFICATE_MODALS_INVALID_DATE_VALI = "certificateModalsInvalidDateValidation";
export const CERTIFICATE_MODALS_EDIT_CERTIFICATE_LABEL = "certificateModalsEditCertificateLabel";
export const CERTIFICATE_MODALS_DELETE_CERTIFICATE_LABEL = "certificateModalsDeleteCertificateLabel";
export const CERTIFICATE_MODALS_DELETE_CERTIFICATE_WARN = "certificateModalsDeleteCertificateWarning";
export const ADD_COURSE_LABEL = "addCourseLabel";
export const ADD_COURSE_TEMPLATE_LABEL = "addCourseTemplateLabel";
export const ADD_COURSE_BUTTON_LABEL = "addCourseButtonLabel";
export const ADD_CERTIFICATE_LABEL = "addCertificateLabel";
export const ADD_CERTIFICATE_BUTTON_LABEL = "addCertificateButtonLabel";
export const EDIT_COURSE_LABEL = "editCourseLabel";
export const DUPLICATE_COURSE_LABEL = "duplicateCourseLabel";
export const DUPLICATE_COURSE_OL_BOOKING_WARN = "duplicateCourseOLBookingWarn";
export const COURSE_TABLE_NAME_COL = "courseTableNameCol";
export const COURSE_TABLE_LANG_COL = "courseTableLangCol";
export const COURSE_TABLE_START_DATE_COL = "courseTableStartDateCol";
export const COURSE_TABLE_END_DATE_COL = "courseTableEndDateCol";
export const COURSE_TABLE_NUM_BOOKINGS_COL = "courseTableNumBookingsCol";
export const COURSE_TABLE_IS_REGISTERED_COL = "courseTableIsRegisteredCol";
export const COURSE_TABLE_TEACHER_NAME_COL = "courseTableTeacherNameCol";
export const COURSE_TABLE_STATUS_COL = "courseTableStatusCol";
export const COURSE_TABLE_CATEGORY_COL = "courseTableCategoryCol";
export const COURSE_TABLE_NO_START_DATE = "courseTableNoStartDate";
export const COURSE_TABLE_NO_END_DATE = "courseTableNoEndDate";
export const COURSE_TABLE_RESERVE_SPOTS_OPEN = "courseTableReserveSpotOpen";
export const EXL_NAV_MENU_BACK_BUTTON = "exlNavMenuBackButton";
export const EXL_NAV_MENU_COURSES_BUTTON = "exlNavMenuCoursesButton";
export const EXL_NAV_MENU_TEACHERS_BUTTON = "exlNavMenuTeachersButton";
export const EXL_NAV_MENU_REPORTS_BUTTON = "exlNavMenuReportsButton";
export const TEACHER_TABLE_NAME_COL = "teacherTableNameCol";
export const TEACHER_TABLE_EMAIL_COL = "teacherTableEmailCol";
export const TEACHER_TABLE_STATUS_COL = "teacherTableStatusCol";
export const TEACHER_TABLE_NUM_COURSES_COL = "teacherTableNumCoursesCol";
export const LECTURE_DETAILS_DELETE_LECTURE_WARN = "lectureDetailsDeleteLectureWarn";
export const LECTURE_DETAILS_HEADER_EDIT_LECTURE = "lectureDetailsHeaderEditLecture";
export const LECTURE_DETAILS_HEADER_EDIT_ATTENDANCE = "lectureDetailsHeaderEditAttendance";
export const LECTURE_DETAILS_HEADER_NO_PARTICIPANTS = "lectureDetailsHeaderNoParticipants";
export const LECTURE_DETAILS_HEADER_DELETE_LECTURE = "lectureDetailsHeaderDeleteLecture";
export const LECTURE_DETAILS_BODY_NO_DESC = "lectureDetailsBodyNoDesc";
export const LECTURE_DETAILS_BODY_LECTURE_INFO_LABEL = "lectureDetailsBodyLectureInfoLabel";
export const LECTURE_DETAILS_BODY_ATTENDANCE_LABEL = "lectureDetailsBodyLectureAttendanceLabel";
export const GENERAL_LECTURE_INFO_TEACHER_LABEL = "generalLectureInfoTeacherLabel";
export const GENERAL_LECTURE_INFO_LECTURE_TIME = "generalLectureInfoLectureTimeLabel";
export const GENERAL_LECTURE_INFO_LECTURE_ADDRESS_LABEL = "generalLectureInfoLectureAddressLabel";
export const GENERAL_LECTURE_INFO_NO_SET_ADDRESS = "generalLectureInfoNoSetAddress";
export const GENERAL_LECTURE_INFO_PARENT_COURSE = "generalLectureInfoParentCourseLabel";
export const GENERAL_LECTURE_INFO_MEETING_LINK_LABEL = "generalLectureInfoMeetingLinkLabel";
export const GENERAL_LECTURE_INFO_NO_SET_MEETING_LINK = "generalLectureInfoNoSetMeetingLink";
export const LECTURE_ATTENDANCE_NO_PARTICIPANTS = "lectureAttendanceNoParticipants";
export const LECTURE_ATTENDANCE_USE_MODAL_TOOLTIP = "lectureAttendanceUseModalTooltip";
export const TEACHER_DETAILS_UPLOAD_CV_LABEL = "teacherDetailsUploadCVLabel";
export const TEACHER_DETAILS_DELETE_TEACHER_WARN = "teacherDetailsDeleteTeacherWarn";
export const TEACHER_DETAILS_DELETE_TEACHER_CV_WARN = "teacherDetailsDeleteTeacherCVWarn";
export const TEACHER_DETAILS_HEADER_EDIT_TEACHER_LABEL = "teacherDetailsHeaderEditTeacherLabel";
export const TEACHER_DETAILS_HEADER_UPLOAD_CV_LABEL = "teacherDetailsHeaderUploadCVLabel";
export const TEACHER_DETAILS_HEADER_DELETE_CV_LABEL = "teacherDetailsHeaderDeleteCVLabel";
export const TEACHER_DETAILS_HEADER_DELETE_TEACHER_LABEL = "teacherDetailsHeaderDeleteTeacherLabel";
export const TEACHER_DETAILS_HEADER_TEACHER_LABEL = "teacherDetailsHeaderTeacherLabel";
export const TEACHER_DETAILS_HEADER_TEACHER_IS_ONLY_TEACHER_WARN = "teacherDetailsHeaderTeacherIsOnlyTeacherWarn";
export const TEACHER_DETAILS_BODY_TEACHER_DESC_LABEL = "teacherDetailsBodyTeacherDescLabel";
export const TEACHER_DETAILS_BODY_EMPTY_TEACHER_DESC = "teacherDetailsBodyEmptyTeacherDescription";
export const TEACHER_DETAILS_BODY_TEACHER_CV_LABEL = "teacherDetailsBodyTeacherCVLabel";
export const TEACHER_DETAILS_BODY_NO_TEACHER_CV = "teacherDetailsBodyNoTeacherCV";
export const TEACHER_DETAILS_BODY_TEACHER_INFO_LABEL = "teacherDetailsBodyTeacherInfoLabel";
export const TEACHER_DETAILS_BODY_TEACHER_COURSES_LABEL = "teacherDetailsBodyTeacherCoursesLabel";
export const GENERAL_TEACHER_INFO_NAME_LABEL = "generalTeacherInfoNameLabel";
export const GENERAL_TEACHER_INFO_EMAIL_LABEL = "generalTeacherInfoEmailLabel";
export const GENERAL_TEACHER_INFO_COMP_TYPE_LABEL = "generalTeacherInfoCompTypeLabel";
export const GENERAL_TEACHER_INFO_STATUS_LABEL = "generalTeacherInfoStatusLabel";
export const TEACHER_COURSES_FILTER_TOOLTIP = "teacherCoursesFilterTooltip";
export const TEACHER_COURSES_NO_COURSES = "teacherCoursesNoCourses";
export const TEACHER_COURSES_COURSES_LABEL = "teacherCoursesCoursesLabel";
export const TEACHER_COURSES_COURSE_START_LABEL = "teacherCoursesCourseStartLabel";
export const TEACHER_COURSES_COURSE_END_LABEL = "teacherCoursesCourseEndLabel";
export const TEACHER_COURSES_COURSE_STATUS_LABEL = "teacherCoursesCourseStatusLabel";
export const TEACHER_COURSES_COURSE_CATEGORY_LABEL = "teacherCoursesCourseCategoryLabel";
export const TEACHER_COURSES_NO_SET_DATE = "teacherCoursesNoSetDate";
export const LECTURE_MODALS_NAME_LABEL = "lectureModalsNameLabel";
export const LECTURE_MODALS_NO_NAME_VALI = "lectureModalsNoNameValidation";
export const LECTURE_MODALS_DESC_LABEL = "lectureModalsDescLabel";
export const LECTURE_MODALS_TEACHERS_LABEL = "lectureModalsTeachersLabel";
export const LECTURE_MODALS_NO_TEACHERS_VALI = "lectureModalsNoTeachersValidation";
export const LECTURE_MODALS_INVALID_TIME_VALI = "lectureModalsInvalidTimeValidation";
export const LECTURE_MODALS_MEETING_LINK_LABEL = "lectureModalsMeetingLinkLabel";
export const ADD_LECTURE_ADD_NEW_LECTURE_LABEL = "addLectureAddNewLectureLabel";
export const EDIT_DATE_TIME_LECTURE_DATE_LABEL = "editDateTimeLectureDateLabel";
export const EDIT_DATE_TIME_LECTURE_START_LABEL = "editDateTimeLectureStartLabel";
export const EDIT_DATE_TIME_LECTURE_END_LABEL = "editDateTimeLectureEndLabel";
export const EDIT_LECTURE_LABEL = "editLectureLabel";
export const ADD_TEACHER_BUTTON_LABEL = "addTeacherButtonLabel";
export const ADD_TEACHER_LABEL = "addTeacherLabel";
export const TEACHER_MODALS_NAME_LABEL = "teacherModalsNameLabel";
export const TEACHER_MODALS_NO_NAME_VALI = "teacherModalsNoNameValidation";
export const TEACHER_MODALS_EMAIL_LABEL = "teacherModalsEmailLabel";
export const TEACHER_MODALS_INVALID_EMAIL_VALI = "teacherModalsInvalidEmailValidation";
export const TEACHER_MODALS_DESC_LABEL = "teacherModalsDescLabel";
export const TEACHER_MODALS_COMP_TYPE_LABEL = "teacherModalsCompTypeLabel";
export const TEACHER_MODALS_NO_COMP_TYPE_VALI = "teacherModalsNoCompTypeValidation";
export const TEACHER_MODALS_EMAIL_NOTI_LABEL = "teacherModalsEmailNotiLabel";
export const EDIT_TEACHER_LABEL = "editTeacherLabel";
export const EDIT_TEACHER_IS_ACTIVE_LABEL = "editTeacherIsActiveLabel";
export const EDIT_COURSE_BOOKINGS_OL_BOOKING_WARN = "editCourseBookingsOLBookingWarn";
export const EDIT_COURSE_BOOKINGS_LABEL = "editCourseBookingsLabel";
export const EDIT_COURSE_BOOKINGS_NEW_PARTICIPANT = "editCourseBookingsNewParticipantLabel";
export const EDIT_COURSE_BOOKINGS_FULL_COURSE_WARN = "editCourseBookingsFullCourseWarn";
export const BOOKINGS_LIST_NEW_PARTICIPANT = "bookingsListNewParticipant";
export const EDIT_LECTURE_ATTENDANCE_LABEL = "editLectureAttendanceLabel";
export const CREATE_REPORT_BASE_TYPE_LABEL = "createReportBaseTypeLabel";
export const CREATE_REPORT_TEACHER_LABEL = "createReportTeacherLabel";
export const CREATE_REPORT_NO_TEACHER_WARN = "createReportNoTeacherWarn";
export const CREATE_REPORT_COURSE_LABEL = "createReportCourseLabel";
export const CREATE_REPORT_NO_COURSE_WARN = "createReportNoCourseWarn";
export const CREATE_REPORT_NUM_PARTICIPANTS_LABEL = "createReportNumParticipantsLabel";
export const CREATE_REPORT_PARTICIPANT_INFO_LABEL = "createReportParticipantInfoLabel";
export const CREATE_REPORT_NUM_CANCELLATIONS_LABEL = "createReportNumCancellationsLabel";
export const CREATE_REPORT_NUM_CERTIFICATIONS_LABEL = "createReportNumCertificationsLabel";
export const CREATE_REPORT_NUM_COURSES_LABEL = "createReportNumCoursesLabel";
export const CREATE_REPORT_NUM_WORKED_HOURS_LABEL = "createReportNumWorkedHoursLabel";
export const CREATE_REPORT_CHOOSE_ONE_OPTION_WARN = "createReportChooseOneOptionWarn";
export const CREATE_REPORT_FROM_LABEL = "createReportFromLabel";
export const CREATE_REPORT_TO_LABEL = "createReportToLabel";
export const CREATE_REPORT_NO_FROM_DATE_VALI = "createReportNoFromDateValidation";
export const CREATE_REPORT_NO_TO_DATE_VALI = "createReportNoToDateValidation";
export const CREATE_REPORT_LABEL = "createReportLabel";

/*REGISTRET CONSTANTS*/
export const EMP_TABLE_NAME_COL = "empTableNameCol";
export const EMP_TABLE_ROLE_COL = "empTableRoleCol";
export const EMP_TABLE_BOSS_COL = "empTableBossCol";
export const EMP_TABLE_COMPANY_COL = "empTableCompanyCol";
export const EMP_TABLE_HOURS_COL = "empTableHoursCol";
export const EMP_TABLE_OFFICE_COL = "empTableOfficeCol";
export const EMP_TABLE_STATUS_COL = "empTableStatusCol";
export const EMP_TABLE_CAR_COL = "empTableCarCol";
export const EMP_TABLE_PHONE_COL = "empTablePhoneCol";
export const EMP_TABLE_EMAIL_COL = "empTableEmailCol";
export const EMP_TABLE_BIRTHDATE_COL = "empTableBirthdateCol";
export const EMP_TABLE_ADDRESS_COL = "empTableAddressCol";
export const EMP_TABLE_COMPETENCE_COL = "empTableCompetenceCol";
export const EMP_TABLE_START_DATE_COL = "empTableStartDateCol";
export const EMP_TABLE_END_DATE_COL = "empTableEndDateCol";
export const EMP_TABLE_STATUS_LABEL = "empTableStatusLabel";
export const EMP_TABLE_HOURS_DESC = "empTableHoursDesc";
export const EMP_IS_WORKING = "empIsWorking";
export const EMP_HAS_QUIT = "empHasQuit";
export const EMP_WILL_START = "empWillStart";
export const NAV_MENU_HOME = "navMenuHome";
export const NAV_MENU_SV_OPTION = "navMenuSweOption";
export const NAV_MENU_EN_OPTION = "navMenuEnOption";
export const NAV_MENU_MY_PROFILE_OPT = "navMenuMyProfileOpt";
export const NAV_MENU_LOGS_OPT = "navMenuLogsOpt";
export const NAV_MENU_CRM_OPT = "navMenuCRMOpt";
export const NAV_MENU_EXL_OPT = "navMenuExlOpt";
export const NAV_MENU_LOGOUT_OPT = "navMenuLogoutOpt";
export const HOME_EMPLOYEE_OPT = "homeEmployeeOpt";
export const HOME_CUSTOMER_OPT = "homeCustomerOpt";
export const HOME_OFFICE_OPT = "homeOfficeOpt";
export const HOME_COVERINGS_OPT = "homeCoveringsOpt";

export const EMPLOYEE_DETAILS_INFORMATION_LABEL = "employeeInformationLabel";
export const EMPLOYEE_DETAILS_BILLING_LABEL = "employeeBillingLabel";
export const EMPLOYEE_DETAILS_HOURS_LABEL = "employeeHoursLabel";
export const EMPLOYEE_DETAILS_HOURS_DESC = "employeeHoursDesc";
export const EMPLOYEE_DETAILS_COURSE_LABEL = "employeeCourseLabel";
export const EMPLOYEE_DETAILS_CERTIFICATIONS_LABEL = "employeeCertificationsLabel";
export const EMPLOYEE_DETAILS_OFFICE_LABEL = "employeeOfficeLabel";
export const EMPLOYEE_DETAILS_COMPANY_LABEL = "employeeCompanyLabel";
export const EMPLOYEE_DETAILS_START_DATE_LABEL = "employeeStartDateLabel";
export const EMPLOYEE_DETAILS_END_DATE_LABEL = "employeeEndDateLabel";
export const EMPLOYEE_DETAILS_SKILLS_LABEL = "employeeSkillsLabel";
export const EMPLOYEE_DETAILS_PHONE_NUMBER_LABEL = "employeePhoneNumberLabel";
export const EMPLOYEE_DETAILS_CAR_LABEL = "employeeCarLabel";
export const EMPLOYEE_DETAILS_INVOICE_LABEL = "employeeInvoiceLabel";
export const EMPLOYEE_DETAILS_AMOUNT_LABEL = "employeeAmountLabel";
export const EMPLOYEE_DETAILS_BIRTH_DATE_LABEL = "employeeBirthDateLabel";
export const EMPLOYEE_DETAILS_ADRESS_LABEL = "employeeAdressLabel";
export const EMPLOYEE_DETAILS_EMAIL_LABEL = "employeeEmailLabel";
export const EMPLOYEE_DETAILS_NAV_MENU_BACK_BUTTON = "employeeNavMenuBackButton";
export const EMPLOYEE_DETAILS_NO_BILLING_INFO = "employeeNoBillingInfo";
export const EMPLOYEE_DETAILS_NO_COURSES_INFO = "employeeNoCoursesInfo";
export const EMPLOYEE_DETAILS_NO_CERTIFICATES_INFO = "employeeNoCertificatesInfo";
export const EMPLOYEE_DETAILS_COURSE_STATUS_DESC = "employeeCourseStatusDesc";
export const EMPLOYEE_DETAILS_COURSE_ROLE_DESC = "employeeCourseRoleDesc";
export const EMPLOYEE_DETAILS_HOURS = "employeeDetailsHours";
export const EMPLOYEE_DETAILS_DATE = "employeeDetailsDate";
export const EMPLOYEE_DETAILS_PROJECT_LABEL = "employeeDetailsProjectLabel";
export const EMPLOYEE_DETAILS_DESCRIPTION_LABEL = "employeeDetailsDescriptionLabel";
export const EMPLOYEE_DETAILS_NO_INTERNAL_HOURS_LABEL = "employeeDetailsNoInternalHoursLabel";

export const CUSTOMER_NAME_COL = "customerNameCol";
export const CUSTOMER_KAM_EMP_NAME_COL = "customerKamEmpNameCol";
export const CUSTOMER_ECO_EMP_NAME_COL = "customerEcoEmpNameCol";
export const CUSTOMER_LATEST_INVOICE_MONTH_COL = "customerLatestInvoiceMonthCol";
export const CUSTOMER_LATEST_INVOICE_AMOUNT_COL = "customerLatestInvoiceAmountCol";
export const CUSTOMER_MORE_THAN_ONE_YEAR_LABEL = "customerMoreThanOneYearLabel";

export const CUSTOMER_INVOICE_INFO_DATE_COL = "customerInvoiceInfoDateCol";
export const CUSTOMER_INVOICE_INFO_CONSULTANT_COL = "customerInvoiceInfoConsultantCol";
export const CUSTOMER_INVOICE_INFO_HOURS_COL = "customerInvoiceInfoHoursCol";
export const CUSTOMER_INVOICE_INFO_LATEST_INVOICE_AMOUNT_COL = "customerInvoiceInfoLatestInvoiceAmountCol";
export const CUSTOMER_INVOICE_INFO_INVOICE_NUM_COL = "customerInvoiceInfoInvoiceNumCol";
export const CUSTOMER_INVOICE_INFO_NO_INVOICE_WARN = "customerInvoiceInfoNoInvoiceWarn";

export const CUSTOMER_DETAILS_KAM_EMP_NAME_LABEL = "customerDetailsKamEmpNameLabel";
export const CUSTOMER_DETAILS_BACK_BUTTON = "customerDetailsBackButton";
export const CUSTOMER_DETAILS_ECO_EMP_NAME_LABEL = "customerDetailsEcoEmpNameLabel";

export const OFFICE_TABLE_INFO_BUTTON = "officeTableInfoButton";
export const OFFICE_TABLE_INTERNAL_HOURS_BUTTON = "officeTableInternalHoursButton";
export const OFFICE_TABLE_NAME_COL = "officeTableNameCol";
export const OFFICE_TABLE_BOSS_NAME_COL = "officeTableBossNameCol";
export const OFFICE_TABLE_TOTAL_EMPLOYEES_COL = "officeTableTotalEmployeesCol";
export const OFFICE_TABLE_TOTAL_CONSULTANTS_COL = "officeTableTotalConsultantsCol";

export const OFFICE_DETAILS_BACK_BUTTON = "officeDetailsBackButton";
export const OFFICE_DETAILS_INFORMATION_LABEL = "officeDetailsInformationLabel";
export const OFFICE_DETAILS_NAME_LABEL = "officeDetailsNameLabel";
export const OFFICE_DETAILS_IN_SHAREPOINT_LABEL = "officeDetailsInSharepointLabel";
export const OFFICE_DETAILS_BOSS_NAME_LABEL = "officeDetailsBossNameLabel";
export const OFFICE_DETAILS_TOTAL_EMPLOYEES_LABEL = "officeDetailsTotalEmployeesLabel";
export const OFFICE_DETAILS_TOTAL_CONSULTANTS_LABEL = "officeDetailsTotalConsultantsLabel";

export const COVERING_TABLE_EMP_NAME_COL = "coveringTableEmpNameCol";
export const COVERING_TABLE_EMP_SKILL_COL = "coveringTableEmpSkillCol";
export const COVERING_TABLE_OFFICE_COL = "coveringTableOfficeCol";
export const COVERING_TABLE_REGION_NAME_COL = "coveringTableRegionNameCol";
export const COVERING_TABLE_STATUS_COL = "coveringTableStatusCol";
export const COVERING_TABLE_BOSS_NAME_COL = "coveringTableBossNameCol";
export const COVERING_TABLE_SHOW_ALL_OPT = "coveringTableShowAllOpt";
export const COVERING_TABLE_AVAILABLE_NEXT_FIVE_WEEKS_OPT = "coveringTableAvailableNextFiveWeeksOpt";
export const COVERING_TABLE_AVAILABLE_IN_WEEK_RANGE_OPT = "coveringTableAvailableInWeekRangeOpt";
export const COVERING_TABLE_INTERNAL_HOURS_FTE_OPT = "coveringTableInternalHoursFteOpt"

/*CRM CONSTANTS*/
export const ADD_DEAL_CUSTOMER_LABEL = "addDealCustomer";
export const ADD_DEAL_CONTACT_PERSON_LABEL = "addDealContactPerson";
export const ADD_DEAL_TITLE_LABEL = "addDealTitle";
export const ADD_DEAL = "addDeal";
export const NOTHING = "nothing";
export const ADD_TITLE = "addTitle";
export const CANCEL_WARNING = "cancelWarning";
export const NOTE_INPUT = "noteInput";
export const BOOKED_CUSTOMER = "bookedCustomer";
export const COMPLETED_CUSTOMER_MEETING = "completedCustomerMeeting";
export const YEARLY_INDEX_ADJUSTMENT = "yearlyIndexAdjustment";
export const ITEM_TITLE_CUSTOMER = "customer";
export const ITEM_TITLE_CONTACT_PERSON = "titleContactPerson";
export const ITEM_TITLE_ORGANIZATION = "titleOrganization";
export const ITEM_TITLE_RELATIONS = "relations";
export const ITEM_TITLE_DETAILS = "titleDetails";
export const ITEM_TITLE_COMMITMENT = "commitment";
export const ITEM_TITLE_SCOPE = "scope";
export const ITEM_TITLE_CONTRACT_START = "contractStart";
export const ITEM_TITLE_CONTRACT_END = "contractEnd";
export const ITEM_TITLE_OPTION_LENGTH = "optionLength";
export const ITEM_TITLE_HOURLY_RATE = "hourlyRate";
export const ITEM_TITLE_CONSID_CONSULTANTS = "considConsultants";
export const ITEM_TITLE_UC_COMPANY = "ucCompany";
export const ITEM_TITLE_SUBCONTRACTORS = "subcontractors";
export const ITEM_TITLE_UC_PRICE_IN = "ucPriceIn";
export const ITEM_TITLE_UC_MARGIN = "ucMargin";
export const ITEM_TITLE_CONTRACT_UPLOADED = "contractUploaded";
export const ITEM_TITLE_INVOICE_REFERENCE = "invoiceReference";
export const ITEM_TITLE_LOSS_CAUSE = "lossCause";
export const ITEM_TITLE_COLLABORATORS = "collaborators";
export const ITEM_TITLE_FOLLOWERS = "followers";
export const ITEM_TITLE_LOCATION = "location";
export const ITEM_TITLE_OTHER_LOCATION = "otherLocation";
export const ITEM_TITLE_TECHNICAL_ENVIRONMENT = "technicalEnvironment";
export const ITEM_TITLE_FRAMEWORK_AGREEMENT = "frameworkAgreement";
export const ITEM_TITLE_PUBLIC_SECTOR = "publicSector";
export const ITEM_TITLE_INVOICE_ADDRESS = "invoiceAddress";
export const ITEM_TITLE_COMPANY = "company";
export const ITEM_TITLE_TEST_ORG = "testOrg";
export const ITEM_TITLE_ROLE = "role";
export const ITEM_TITLE_UNKNOWN = "unknown";
export const ITEM_TITLE_OTHER_ROLE = "otherRole";
export const ITEM_TITLE_PHONE = "phone";
export const ITEM_TITLE_EMAIL = "email";
export const ITEM_TITLE_PARENT_COMPANY = "parentCompany";
export const ITEM_TITLE_DAUGHTER_COMPANY = "daughterCompany";
export const UNABLE_TO_CREATE_SUBCONTRACTOR = "unableToCreateSubContractor";
export const UNABLE_TO_CREATE_SUBCONTRACTOR_BEFORE_ADDING_ORG = "unableToCreateSubContractorBeforeAddOrganization";
export const REMOVE_FILE_WARNING = "removeFileWarning";
export const REMOVE_ACTIVITY_WARNING = "removeActivityWarning";
export const REMOVE_NOTE_WARNING = "removeNoteWarning";
export const ITEM_ALL = "all";
export const ITEM_ACTIVITY = "activity";
export const ITEM_ACTIVITIES = "activities";
export const ITEM_NOTES = "notes";
export const ITEM_FILES = "files";
export const ITEM_CHANGELOG = "changelog";
export const DROPDOWN_ITEM_BUSINESS_MODE = "businessMode";
export const DROPDOWN_ITEM_AVAILABLE_CONSULTS = "availableConsults";
export const DROPDOWN_ITEM_ORGANIZATIONS = "organizations";
export const DROPDOWN_ITEM_PEOPLE = "people";
export const DROPDOWN_ITEM_ACTIVITIES = "activities";
export const DROPDOWN_ITEM_ACTIVE_DEALS = "activeDeals";
export const DROPDOWN_ITEM_FOLLOW_UP = "followUp";
export const FILTER_ITEM_OWNER = "owner";
export const FILTER_ITEM_STATUS = "status";
export const FILTER_ITEM_PERSONALFILTERS = "personalFilters";
export const FILTER_ITEM_MYDEALS = "myDeals";
export const FILTER_ITEM_EVERYONESDEALS = "everyonesDeals";
export const FILTER_ITEM_ALLDEALS = "allDeals";
export const FILTER_ITEM_USER = "user";
export const FILTER_ITEM_CHANGE_OWNER = "changeOwner";


